import { Modification } from '@acorn-portal/shared/src/services/api';

export interface IAmendVehiclePart2 {
	owner: string;
	registeredKeeper: string;
	vrm: string;
	hasModifications: string;
	modifications: Modification[];
	imported: string;
	isLeftHandDrive: string;
	countryOfRegistration: string;
	purchasedDate: { year: string; month: string };
	keptOvernight: string;
	overnightAddressIsAway: string;
	overnightAddress: {
		line1: string;
		city: string;
		postcode: string;
	};
	value: string;
	levelOfCover: string;
	vehicleUse: string;
	registrationDate?: { year: string; month: string };
}

export const getVehicleInitialValues = (): IAmendVehiclePart2 => {
	return {
		owner: '',
		registeredKeeper: '',
		vrm: '',
		hasModifications: '',
		modifications: [],
		imported: '',
		isLeftHandDrive: '',
		countryOfRegistration: '',
		purchasedDate: { year: '', month: '' },
		keptOvernight: '',
		overnightAddressIsAway: '',
		overnightAddress: {
			line1: '',
			city: '',
			postcode: '',
		},
		value: '',
		levelOfCover: '',
		vehicleUse: '',
		registrationDate: { year: '', month: '' },
	};
};
